import React from 'react'
import useTrans from 'hooks/useTrans'
import { PaginaType } from 'utils/types'
import { BrandCard, DatiFormCard, MyAccountSection } from 'components/molecules'
import { MyAccountDeleteCard, MyAccountAccountFormCard, MyAccountLayout, Page } from 'components/organisms'
import styles from './MyAccountDatiTemplate.module.sass'

interface Props {
  pagina: PaginaType
  utente?: {
    nome?: string
    cognome?: string
    sesso?: string
    dataNascita?: string
    email?: string
  }
}

const MyAccountDatiTemplate = ({ utente, pagina }: Props) => {
  const t = useTrans()
  const email = utente?.email

  return (
    <Page pagina={pagina} item={{}}>
      <MyAccountLayout
        titolo={pagina.titolo}
        menuActiveItemKey="profile"
        backLink={false}
      >
        <MyAccountSection>
          <DatiFormCard dati={{ ...utente }} />
        </MyAccountSection>
        <MyAccountSection>
          <MyAccountAccountFormCard dati={{ email }} />
        </MyAccountSection>
        <MyAccountSection>
          <MyAccountDeleteCard />
        </MyAccountSection>
        <MyAccountSection>
          <BrandCard/>
        </MyAccountSection>
      </MyAccountLayout>
    </Page>
  )
}

export default MyAccountDatiTemplate
